import { XmlEntities } from 'html-entities'
import C from 'actionTypes'

const defaultState = {
  primaryPortfolioHoldings: [],
}

const primaryPortfolioHoldings = (state = defaultState, action) => {
  switch (action.type) {
    case C.SET_PRIMARY_PORTOFLIO_HOLDINGS:
      const { data } = action
      return {
        ...state,
        primaryPortfolioHoldings: data.holdings.map(holding => ({
          ...holding,
          attributes: {
            ...holding.attributes,
            assetName: XmlEntities.decode(holding.attributes.assetName),
            className: XmlEntities.decode(holding.attributes.className),
          }
        })),
      }
    default:
      return state
  }
}
export default primaryPortfolioHoldings



// WEBPACK FOOTER //
// ./src/reducers/client/primaryPortfolioHoldings.js